export const LOCAL_STORAGE_USER_ID_KEY = 'orama_user_id';
